/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { IVCSStrictHttpResponse } from '../../ivcs-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { RxItemModel } from '../../models/rx-item-model';

export interface ConsumerUpdatePrescriptionItemsPost$Json$Params {
      body?: Array<RxItemModel>
}

export function consumerUpdatePrescriptionItemsPost$Json(http: HttpClient, rootUrl: string, params?: ConsumerUpdatePrescriptionItemsPost$Json$Params, context?: HttpContext): Observable<IVCSStrictHttpResponse<Array<RxItemModel>>> {
  const rb = new RequestBuilder(rootUrl, consumerUpdatePrescriptionItemsPost$Json.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as IVCSStrictHttpResponse<Array<RxItemModel>>;
    })
  );
}

consumerUpdatePrescriptionItemsPost$Json.PATH = '/Consumer/UpdatePrescriptionItems';
